



































































import { Component, Mixins, Watch, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import {
  TabSelector,
} from "../../../../base/components/system/selectors";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { default as FilterableFormatsSelector } from "./FilterableFormatsSelector.vue";
import { default as UserEditedFormatsSelector } from "./UserEditedFormatsSelector.vue";
import { default as DeletedFormatSelector } from "./DeletedFormatSelector.vue";
import { FormatTreeSource, PublicFormatTreeSource, IEditableFormatTreeSource } from "./trees/sources";

@Component({
  components: {
    TabSelector,
    FilterableFormatsSelector,
    UserEditedFormatsSelector,
    DeletedFormatSelector,
  }
})
export default class FormatTwoPaneSelector extends Mixins(ModelEditableMixin) {
  listTabs: { name: string, description: string }[] = [
    {
      name: "作成フォーマット",
      description: "作成したフォーマットから絞り込んで表示します。",
    },
    {
      name: "公開フォーマット",
      description: "公開されたフォーマットを表示します。"
    },
    {
      name: "最近編集したフォーマット",
      description: "最近自分が編集したフォーマットを表示します。",
    },
    {
      name: "削除フォーマット",
      description: "削除されたフォーマットを表示します。"
    },
  ];
  ownFormatTab = this.listTabs[0];
  publicFormatTab = this.listTabs[1];
  recentFormatTab = this.listTabs[2];
  deletedFormatTab = this.listTabs[3];
  selectedListTab: { name: string, description: string } = this.listTabs[0];
  selectionOfOwnFilterableFormat: EditableFormatSummary = null;
  selectionOfPublicFilterableFormat: EditableFormatSummary = null;
  selectionOfUserEditedFormat: EditableFormatSummary = null;
  selectionOfDeletedFormat: EditableFormatSummary = null;

  $refs!: {
    filterableOwnFormatsSelector: FilterableFormatsSelector,
    filterablePublicFormatsSelector: FilterableFormatsSelector,
    userEditedFormatsSelector: UserEditedFormatsSelector,
    deletedFormatsSelector: DeletedFormatSelector,
  };

  get ownFormatsSource(): IEditableFormatTreeSource {
    return new FormatTreeSource();
  }

  get publicFormatsSource(): IEditableFormatTreeSource {
    return new PublicFormatTreeSource();
  }

  get visibleListTabs(): { name: string, description: string }[] {
    return this.listTabs.filter(t => t !== this.publicFormatTab || this.$configuration.behavior.format.editor.sharing.isEnable);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  mounted() {
    window.addEventListener("message", this.onChildWindowNotify, false);
  }

  private onChildWindowNotify(event: any): void {
    try {
      const message = JSON.parse(event.data) as { key: string };
      if (message.key === "finishEditing") {
        this.updateListTab();
      }
    } catch {}
  }

  @Watch("selectedListTab")
  onSelectedListTabUpdated(newValue: { name: string, description: string }, oldValue: { name: string, description: string }): void {
    switch (newValue.name) {
      case this.ownFormatTab.name:
        this.editingSource = this.selectionOfOwnFilterableFormat;
        break;
      case this.publicFormatTab.name:
        this.editingSource = this.selectionOfPublicFilterableFormat;
        break;
      case this.recentFormatTab.name:
        this.editingSource = this.selectionOfUserEditedFormat;
        break;
      case this.deletedFormatTab.name:
        this.editingSource = this.selectionOfDeletedFormat;
        break;
    }
    this.selectedListTabChanged(this.replaceWording(newValue.name));
  }

  @Watch("selectionOfOwnFilterableFormat")
  onSelectionOfOwnFilterableFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfOwnFilterableFormat;
  }

  @Watch("selectionOfPublicFilterableFormat")
  onSelectionOfPublicFilterableFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfPublicFilterableFormat;
  }

  @Watch("selectionOfUserEditedFormat")
  onSelectionOfUserEditedFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfUserEditedFormat;
  }

  @Watch("selectionOfDeletedFormat")
  onSelectionOfDeletedFormatUpdated(newValue: EditableFormatSummary, oldValue: EditableFormatSummary): void {
    this.editingSource = this.selectionOfDeletedFormat;
  }

  shouldShowListContent(source: { name: string, description: string }): boolean {
    return this.selectedListTab
        && (this.selectedListTab.name === source.name);
  }

  updateListTab(): void {
    switch (this.selectedListTab.name) {
      case this.ownFormatTab.name:
        this.$refs.filterableOwnFormatsSelector.loadFormatTree();
        break;
      case this.publicFormatTab.name:
        this.$refs.filterablePublicFormatsSelector.loadFormatTree();
        break;
      case this.recentFormatTab.name:
        this.$refs.userEditedFormatsSelector.loadUserEditedFormats();
        break;
      case this.deletedFormatTab.name:
        this.$refs.deletedFormatsSelector.loadDeletedFormats();
        break;
    }
  }

  showEditHistory(): void {
    this.$openWindow("/ShowEditHistory");
  }

  @Emit("editingFormat")
  editingFormat(value: boolean): void {}

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}

  @Emit("folderSelectionChanged")
  folderSelectionChanged(formats: EditableFormatSummary[]): void {}

  @Emit("selectedListTabChanged")
  selectedListTabChanged(name: string): void {}
}
